<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <MessageLogsList global />
      </div>
    </v-card>
  </div>
</template>

<script>
import MessageLogsList from "@/components/admin/messager/MessageLogsList.vue";

export default {
  metaInfo() {
    return { title: "Mensageria" };
  },
  components: { MessageLogsList },
};
</script>
